<section class="date-pagination">
  <mat-button-toggle-group
    #dateSizePicker="matButtonToggleGroup"
    (change)="setDateSize(dateSizePicker.value)"
    [value]="dateSize"
    >
    <mat-button-toggle value="day"> Day </mat-button-toggle>
    <mat-button-toggle value="week"> Week </mat-button-toggle>
    <mat-button-toggle value="month"> Month </mat-button-toggle>
  </mat-button-toggle-group>
  @if (dateSize !== 'day') {
    <section class="date-range">
      {{ DateRange.startDate | date : 'd MMM yyyy' }}{{ DateRange?.endDate ?
      (DateRange.endDate | date : ' - d MMM yyyy') : '' }}
    </section>
  }
  @if (dateSize === 'day') {
    <section class="date-range">
      {{ DateRange.startDate | date : 'd MMM yyyy' }}
    </section>
  }
  <section class="date-navigation">
    <button (click)="decrementStartDate()" mat-raised-button>
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <button (click)="startDateToday()" mat-raised-button>Today</button>
    <button (click)="incrementStartDate()" mat-raised-button>
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </section>
</section>
